export class EdgeEnvironment {
  public static getName = () => 'benzinga-edge';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://www.benzinga.com/'),
  });
}
